<template>
  <div class="c-card-off">
    <section class="c-card-off__section">
      <div class="c-card-off__img-wrapper"></div>
      <div class="c-card-off__info">
        <div class="c-card-off__info-content">
          <img
            src="@/projects/synergy/assets/img/card-off/logo-synergy-id.svg"
            alt="avatar"
            class="c-card-off__info-img"
          />
          <h1 class="c-card-off__info-title">
            {{ title }}
          </h1>
          <p class="c-card-off__info-subtitle">
            {{ subtitle }}
          </p>
          <p
            v-if="details"
            class="c-card-off__info-text"
          >
            {{ details }}
          </p>
          <p class="c-card-off__info-text">
            Для решения срочных вопросов свяжитесь со службой поддержки
            <a
              href="mailto:help@synergyfriends.ru"
              class="c-card-off__info-text--color"
            > help@synergyfriends.ru </a>
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'TheCabinetOff',
  props: {
    title: {
      type: String,
      default: 'Tехнические работы',
    },
    subtitle: {
      type: String,
      default:
        'Мы меняемся к лучшему, поэтому сейчас проводим технические работы. Очень скоро личный кабинет снова станет доступен. Пожалуйста, попробуйте позднее.',
    },
    details: {
      type: String,
      default: '',
    },
  },
});
</script>

<style lang="scss">
@import './TheCabinetOff.scss';
</style>
